class BenefitsAccordion extends HTMLElement {
  connectedCallback() {
    if (this.isConnectedAndReady) return;
    this.isConnectedAndReady = true;
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.isConnectedAndReady = false;
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const trigger = event.target.closest('[data-benefit-trigger]');
    if (!(trigger instanceof HTMLButtonElement) || !this.contains(trigger)) return;

    const item = trigger.closest('[data-benefit-item]');
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;
    if (!(item instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;

    const willOpen = trigger.getAttribute('aria-expanded') !== 'true';

    this.querySelectorAll('[data-benefit-item]').forEach((candidate) => {
      const candidateTrigger = candidate.querySelector('[data-benefit-trigger]');
      const candidatePanel = candidate.querySelector('[data-benefit-panel]');
      const isCurrent = candidate === item && willOpen;

      candidate.classList.toggle('is-open', isCurrent);
      candidateTrigger?.setAttribute('aria-expanded', String(isCurrent));
      if (candidatePanel instanceof HTMLElement) candidatePanel.hidden = !isCurrent;

      const indicator = candidate.querySelector('.benefits-accordion__indicator');
      if (indicator) indicator.textContent = isCurrent ? '−' : '+';
    });
  };
}

if (!customElements.get('benefits-accordion')) {
  customElements.define('benefits-accordion', BenefitsAccordion);
}
